"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSiteNumberInput = validateSiteNumberInput;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var userGroupActions = require("@caddigital/sok-reducers/lib/actions/customer/userGroups");
require("./createEditCustomerGroup.scss");
var mapStateToProps = function (state) {
    return {
        createEdit: state.customer.userGroups.createEdit,
        groups: state.customer.userGroups.groups
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () {
        return dispatch(userGroupActions.createEditGroupModal('NONE', 'NONE'));
    },
    create: function (payload) {
        return dispatch(userGroupActions.createEditRequest(payload));
    }
}); };
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('id', 'setId', null), (0, recompose_1.withState)('selectedCategory', 'setSelectedCategory', null), (0, recompose_1.withState)('name', 'setName', ''), (0, recompose_1.withState)('categories', 'setCategories', []), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if ((this.props.groups !== prevProps.groups &&
            this.props.createEdit.mode !== 'NONE') ||
            (this.props.createEdit.mode !== 'NONE' &&
                this.props.createEdit.mode !== prevProps.createEdit.mode)) {
            this.props.setCategories(this.props.groups.reduce(function (acc, x) {
                if (x.category.type === 'CustomerUserGroup') {
                    acc.push(x.category);
                }
                return acc;
            }, []));
        }
        if (prevProps.createEdit.mode !== 'NONE' &&
            this.props.createEdit.mode !== prevProps.createEdit.mode) {
            this.props.setSelectedCategory(null);
            this.props.setName('');
            this.props.setId(null);
        }
        if (this.props.createEdit.mode === 'EDIT' &&
            (this.props.createEdit.mode !== prevProps.createEdit.mode ||
                this.props.groups !== prevProps.groups) &&
            this.props.createEdit.editGroup !== undefined) {
            var group_1 = this.props.createEdit.editGroup;
            if (this.props.createEdit.type === 'ARCHIVE_USER_PROFILE') {
                var cat = this.props.groups.find(function (x) { return x.category.id === group_1.categoryId; });
                if (cat) {
                    this.props.setSelectedCategory(cat.category);
                }
            }
            this.props.setId(group_1.id);
            this.props.setName(group_1.name);
        }
    },
    shouldComponentUpdate: function (prevProps) {
        if (this.props.createEdit.mode !== prevProps.createEdit.mode ||
            this.props.createEdit.mode !== 'NONE') {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var classes = {
    NONE: '',
    CATEGORY: 'customer-management-user-group-modal-create-edit category',
    USER_PROFILE: 'customer-management-user-group-modal-create-edit user-profile',
    ARCHIVE_CATEGORY: 'customer-management-user-group-modal-create-edit category archive',
    ARCHIVE_USER_PROFILE: 'customer-management-user-group-modal-create-edit user-profile archive'
};
var headerName = {
    NONE: '',
    CATEGORY: 'management/customerGroups/modal/createNewCategory',
    USER_PROFILE: 'management/customerGroups/modal/createNewUserProfile',
    ARCHIVE_CATEGORY: 'management/customerGroups/modal/createNewCategory',
    ARCHIVE_USER_PROFILE: 'management/customerGroups/modal/createNewUserProfile'
};
var groupName = {
    NONE: '',
    CATEGORY: 'management/customerGroups/modal/categoryName',
    USER_PROFILE: 'management/customerGroups/modal/userProfileName',
    ARCHIVE_CATEGORY: 'management/customerGroups/modal/categoryName',
    ARCHIVE_USER_PROFILE: 'management/customerGroups/modal/userProfileName'
};
function validateSiteNumberInput(evt) {
    if (evt.key === 'Enter') {
        return;
    }
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var charFromKey = String.fromCharCode(key);
    var regex = /[0-9]|\./;
    if (!regex.test(charFromKey)) {
        if (theEvent.preventDefault)
            theEvent.preventDefault();
        return false;
    }
}
exports.default = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.createEdit.mode !== 'NONE', className: classes[props.createEdit.type] },
    React.createElement(sok_ui_1.Header, { onClose: props.toggleModal }, (0, translation_1.getLocalization)(headerName[props.createEdit.type])),
    React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            if (props.createEdit.mode === 'NONE' ||
                props.createEdit.type === 'NONE' ||
                props.name.trim().length === 0) {
                return;
            }
            props.create({
                customerId: props.customerId,
                name: props.name.trim(),
                mode: props.createEdit.mode,
                type: props.createEdit.type,
                id: props.id !== null ? props.id : undefined,
                categoryId: props.selectedCategory
                    ? props.selectedCategory.id
                    : undefined
            });
        } },
        React.createElement(sok_ui_1.Container, null,
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.createEdit.status, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                (0, translation_1.getLocalization)('management/customerGroups/modal/saving'),
                (0, translation_1.getLocalization)('management/customerGroups/modal/saved'),
                (0, translation_1.getLocalization)('management/customerGroups/modal/failed')),
            React.createElement("div", { className: 'content' },
                React.createElement(sok_ui_1.Row, null,
                    props.createEdit.mode === 'CREATE' &&
                        props.createEdit.type === 'ARCHIVE_USER_PROFILE' && (React.createElement(sok_ui_1.Column, null,
                        React.createElement("label", { htmlFor: 'category' }, (0, translation_1.getLocalization)('management/customerGroups/modal/category')),
                        React.createElement(sok_ui_1.Dropdown2, { alignment: 'left', className: 'drop-down-selection' },
                            React.createElement(sok_ui_1.TextInput, { id: 'category', editable: false, value: props.selectedCategory
                                    ? props.selectedCategory.name
                                    : (0, translation_1.getLocalization)('management/customerGroups/modal/selectCategory'), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-caret-down' }) }),
                            React.createElement(sok_ui_1.Dropdown2Menu, { key: 'categoryMenu' }, props.groups
                                .filter(function (x) { return x.category.type === 'CustomerCategoryUserGroup'; })
                                .map(function (x) { return (React.createElement(React.Fragment, null,
                                React.createElement(sok_ui_1.Dropdown2MenuItem, { key: x.category.id, selected: props.selectedCategory
                                        ? x.category.id === props.selectedCategory.id
                                        : false, onClick: function () {
                                        return props.setSelectedCategory(x.category);
                                    } }, x.category.name))); }))))),
                    React.createElement(sok_ui_1.Column, null,
                        React.createElement("label", { htmlFor: 'groupname' }, (0, translation_1.getLocalization)(groupName[props.createEdit.type])),
                        React.createElement(sok_ui_1.TextInput, { id: 'groupname', value: props.name, disabled: props.createEdit.type === 'ARCHIVE_USER_PROFILE'
                                ? !props.selectedCategory
                                : false, placeholder: (0, translation_1.getLocalization)(groupName[props.createEdit.type]), onChange: function (e) {
                                return props.setName(e.target.value.toString());
                            }, autoFocus: true }))))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { disabled: props.createEdit.status === 'SAVING' ||
                    props.name.trim().length === 0 ||
                    (props.createEdit.type === 'ARCHIVE_USER_PROFILE'
                        ? props.selectedCategory === null
                        : false), text: (0, translation_1.getLocalization)('buttons/save'), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-piggy-bank' }), color: 'base-green', type: 'submit' }),
            React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('buttons/cancel'), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-arrow-circle-left' }), color: 'dark-gray', onClick: props.toggleModal }))))); });
